<template>
  <div class="audio">
    <div class="audio-wrap">
      <img class="audio-cover" @click="bgMusicPlayOrPause" :src="audioCover" alt />
    </div>
    <audio id="audio-tag" loop ref="audio" :src="info.audioUrl" preload="auto">您的浏览器不支持 audio 标签。</audio>
  </div>
</template>

<script>
import { isMiniApplets } from "@/utils/browser";
export default {
  name: "Audio",
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imgList: [], //存储的audio信息
      playFlag: true, //播放的状态 true是播放，false是暂停
    };
  },
  computed: {
    audioCover() {
      return this.playFlag
        ? this.info.playUrl
        : this.info.stopUrl;
    },
  },
  created() { },
  mounted() {
    this.addEventListenerPage();
  },
  methods: {
    addEventListenerPage() {
      document.addEventListener("visibilitychange", e => {
        // 兼容ios微信手Q
        if (document.hidden) {
          // 网页被挂起
          this.audioPause();
          this.playFlag = false;
        } else {
          if (this.playFlag) {
            this.audioPlayer();
          } else {
            this.audioPause();
          }
        }
      });
      if (document.visibilityState === 'visible') {
        if (this.playFlag) {
          this.audioPlayer();
        } else {
          this.audioPause();
        }
      }
    },
    bgMusicPlayOrPause() {
      this.clickMusicBtn = !this.playFlag;
      if (this.playFlag) {
        this.audioPause();
      } else {
        this.audioAutoPlay();
      }
    },
    audioPause() {
      let audio = this.$refs.audio;
      if (!audio) { return }
      audio.pause();
      this.playFlag = false;
      document.addEventListener(
        "WeixinJSBridgeReady",
        () => {
          audio.pause();
          this.playFlag = false;
        },
        false
      );
      document.addEventListener(
        "YixinJSBridgeReady",
        () => {
          audio.pause();
          this.playFlag = false;
        },
        false
      );
    },
    audioAutoPlay() {
      let audio = this.$refs.audio;
      if (!audio) { return }
      audio.play();
      this.playFlag = true;
      document.addEventListener(
        "WeixinJSBridgeReady",
        () => {
          audio.play();
          this.playFlag = true;
        },
        false
      );
      document.addEventListener(
        "YixinJSBridgeReady",
        () => {
          audio.play();
          this.playFlag = true;
        },
        false
      );
    },
    audioPlayer() {
      let audio = this.$refs.audio;
      if (!audio) { return }
      audio.addEventListener("canplay", () => {
        this.audioAutoPlay(true);
      });
      if (isMiniApplets() == "wechat") {
        document.addEventListener(
          "WeixinJSBridgeReady",
          () => {
            this.audioAutoPlay(true);
          },
          false
        );
        // 添加 getNetworkType 的判断原因, 请看问题分析2
        if (
          typeof window.WeixinJSBridge == "object" &&
          typeof window.WeixinJSBridge.invoke == "function"
        ) {
          window.WeixinJSBridge.invoke("getNetworkType", {}, () => {
            this.audioAutoPlay(true);
          });
        }
      } else {
        this.audioAutoPlay(true);
        let touchPlay = () => {
          this.audioAutoPlay(true);
          document.removeEventListener("touchstart", touchPlay, false);
        };
        document.addEventListener("YixinJSBridgeReady", touchPlay, false);
        if (audio.paused) {
          document.addEventListener("touchstart", touchPlay, false);
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">
.audio-wrap {
  height: 64px;
  width: 64px;

  .audio-cover {
    width: 100%;
    height: 100%;
  }
}

#audio-tag {
  display: none;
}
</style>